import React, { useEffect, useState } from "react";

const CheckPatientModal = ({ ismodal,submit, status, setIsmodal, data, athenaResult, onSaveId }) => {
  // Manual Athena-id entry (Teja request 2026-08-20, parity with hub.dallas):
  // when the patient already exists in Athena — or was created there by hand —
  // staff type the id here to attach it to the onboarding record.
  const [athenaId, setAthenaId] = useState("");
  useEffect(() => {
    if (ismodal) setAthenaId(String(data?.patientid ?? athenaResult?.[0]?.patientid ?? ""));
  }, [ismodal, data?.patientid, athenaResult]);

  if (!ismodal || !data) return null;

  const isFound = status;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-md w-[90%] max-w-md p-6 relative shadow-lg">
        {/* Close Button */}
        <button
          className="absolute top-3 right-3 text-gray-500 hover:text-black text-2xl"
          onClick={() => setIsmodal(false)}
          aria-label="Close"
        >
          &times;
        </button>

        {/* Modal Content */}
        <div className="space-y-4">
          <h2 className="text-xl font-bold border-b pb-2">Patient Details</h2>

          <div className="border rounded-md bg-gray-50 p-4 text-start space-y-2">
            <p className="text-base">
              <span className="font-semibold">Name:</span> {data?.firstname} {data?.lastname}
            </p>
            <p className="text-base">
              <span className="font-semibold">DOB:</span> {data?.dob}
            </p>
            <p className="text-base">
              <span className="font-semibold">Patient ID:</span>
              {data?.patientid ?? athenaResult?.[0]?.patientid ?? ""}
            </p>
          </div>

          {/* Athena id entry — attaches the id to this onboarding record */}
          <div className="flex items-center gap-2">
            <label className="text-sm font-semibold whitespace-nowrap">
              Athena patient id
            </label>
            <input
              type="text"
              className="flex-grow border border-gray-300 rounded px-3 py-1.5 text-sm outline-none"
              placeholder="Enter Athena patient id"
              value={athenaId}
              onChange={(e) => setAthenaId(e.target.value)}
            />
            <button
              disabled={!/^\d+$/.test(athenaId.trim())}
              onClick={() => onSaveId && onSaveId(athenaId.trim())}
              className="px-3 py-1.5 bg-[#50869A] text-white rounded text-sm disabled:opacity-40"
            >
              Save ID
            </button>
          </div>

          {/* Conditional Content */}
          {isFound === true ? (
            <p className="text-red-600 font-medium text-base">
              Patient already exists in Athena — enter their id above and Save.
            </p>
          ) : isFound === false ? (
            <div className="flex justify-end">
              <button
                onClick={() => {
                  // Submit to EMR logic here
                  console.log("Submitting to EMR...");
                 submit()
                }}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Submit to EMR
              </button>
            </div>
          ) : (
            <p className="text-yellow-600 font-medium text-base">
              Something went wrong. Please try again later.
            </p>
          )}

          {/* Close Button */}
          {status&&<div className="flex justify-end">
            <button
              onClick={() => setIsmodal(false)}
              className="px-4 py-2 bg-gray-700 text-white rounded hover:bg-gray-800"
            >
              Close
            </button>
          </div>}
        </div>
      </div>
    </div>
  );
};

export default CheckPatientModal;
